import Vue from 'vue';
import _ from 'lodash';

Vue.directive('debounce', {
  inserted: function (el, binding) {
    el.addEventListener('click', _.debounce(binding.value, 300));
  },
});
